const activityReducer = (state, action) => {
  switch (action.type) {
    case 'CURRENT_ACTIVITY':
      return action.payload;
    default:
      return state;
  }
};

const appReducer = (state, action) => {
  switch (action.type) {
    case 'CURRENT_APP':
      return action.payload;
    default:
      return state;
  }
};

const editReducer = (state, action) => {
  switch (action.type) {
    case 'CURRENT_EDIT':
      return action.payload;
    default:
      return state;
  }
};

const eventReducer = (state, action) => {
  switch (action.type) {
    case 'CURRENT_EVENT':
      return action.payload;
    default:
      return state;
  }
};

const fieldsReducer = (state, action) => {
  switch (action.type) {
    case 'CURRENT_FIELDS':
      return action.payload;
    default:
      return state;
  }
};

const formReducer = (state, action) => {
  switch (action.type) {
    case 'CURRENT_FORM':
      return action.payload;
    default:
      return state;
  }
};

const participantsReducer = (state, action) => {
  switch (action.type) {
    case 'CURRENT_PARTICIPANTS':
      return action.payload;
    default:
      return state;
  }
};

const subactivityReducer = (state, action) => {
  switch (action.type) {
    case 'CURRENT_SUBACTIVITY':
      return action.payload;
    default:
      return state;
  }
};

export {
  activityReducer,
  appReducer,
  editReducer,
  eventReducer,
  fieldsReducer,
  formReducer,
  participantsReducer,
  subactivityReducer
};
